import { Card, Typography } from '@mui/material';
import { TrendingUp, CheckCircle } from 'lucide-react';
import { useState } from 'react';
import { WeeklyStatsPanel } from './subPanel/WeeklyStatsPanel';
import { TaskHistoryPanel } from './subPanel/TaskHistoryPanel';
import { useTranslations } from 'next-intl';

interface StatisticsProps {
  weeklyTotal: number;
  taskHistory: number;
}

export const Statistics = ({
  weeklyTotal,
  taskHistory
}: StatisticsProps) => {
  const t = useTranslations('Statistics');
  const [openPanel, setOpenPanel] = useState<string | null>(null);

  const handleCardClick = (panelType: string) => {
    setOpenPanel(panelType);
  };

  const handleClosePanel = () => {
    setOpenPanel(null);
  };

  const stats = [
    {
      title: t('dataStatistics'),
      subtitle: t('pomodoroTaskStatistics'),
      value: weeklyTotal,
      icon: TrendingUp,
      iconBgColor: 'var(--color-primary-light)',
      iconColor: 'var(--color-primary)',
      panelType: 'weekly'
    },
    {
      title: t('taskHistory'),
      subtitle: t('totalCompletedTasks'),
      value: taskHistory,
      icon: CheckCircle,
      iconBgColor: 'var(--color-primary-light)',
      iconColor: 'var(--color-primary)',
      panelType: 'task'
    }
  ];

  return (
    <>
      <div className="grid grid-cols-2 xl:grid-cols-2 gap-3 pb-4">
        {stats.map((stat) => (
          <Card key={stat.title}
            className="p-3 shadow-none bg-statistics transition-shadow hover:shadow-lg cursor-pointer"
            onClick={() => handleCardClick(stat.panelType)}
            sx={{
              borderRadius: '12px',
              backgroundColor: 'var(--color-statistics-bg)',
              transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
              minWidth: '140px',
              minHeight: '120px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div className="flex flex-col items-center text-center space-y-2 w-full min-w-0 px-1">
              <div className="p-2 rounded-full flex-shrink-0" style={{ backgroundColor: stat.iconBgColor }}>
                <stat.icon className="h-5 w-5" style={{ color: stat.iconColor }} />
              </div>
              <div className="w-full min-w-0">
                <Typography sx={{
                  fontWeight: 600,
                  fontSize: '0.9rem',
                  lineHeight: 1.3,
                  color: 'var(--color-foreground)',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                  hyphens: 'auto',
                  textAlign: 'center'
                }}>
                  {stat.title}
                </Typography>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <WeeklyStatsPanel
        open={openPanel === 'weekly'}
        onClose={handleClosePanel}
      />

      <TaskHistoryPanel
        open={openPanel === 'task'}
        onClose={handleClosePanel}
      />
    </>
  );
};